module.exports = __webpack_public_path__ + "media/img/logos/praenatalzentrum-stuttgart-376900a07ac7107425f7df82363f652c.png";